module.exports = "/images/mountain_left_1x.png";